import { render } from "./StandardWebsites.vue?vue&type=template&id=21518030&scoped=true"
import script from "./StandardWebsites.vue?vue&type=script&lang=js"
export * from "./StandardWebsites.vue?vue&type=script&lang=js"

import "./StandardWebsites.vue?vue&type=style&index=0&id=21518030&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21518030"]])

export default __exports__